import * as React from "react";

function mainIllustration(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 551 600" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M550.725 465.217C550.725 539.656 427.441 600 275.362 600 123.284 600 0 539.656 0 465.217c0-74.438 123.284-134.782 275.362-134.782 152.079 0 275.363 60.344 275.363 134.782z"
        fill="#000"
        fillOpacity={0.05}
      />
      <path
        d="M193.005 574.57l12.334-137.911a1.45 1.45 0 00-2.064-1.395l-24.765 11.648a1.45 1.45 0 00-.825 1.453l8.01 126.145a1.449 1.449 0 001.404 1.308l4.42.117a1.45 1.45 0 001.486-1.365z"
        fill="#99BBE0"
      />
      <path
        d="M191.686 440.376a1.45 1.45 0 00-.858 1.354l-1.642 132.762a1.45 1.45 0 001.41 1.419l.837.022a1.45 1.45 0 001.485-1.364l12.423-137.964a1.45 1.45 0 00-2.037-1.408l-11.618 5.179z"
        fill="#C3DBF5"
      />
      <path
        d="M100.181 521.363l12.335-137.911a1.45 1.45 0 00-2.064-1.395l-24.765 11.648a1.45 1.45 0 00-.825 1.453l8.01 126.145a1.45 1.45 0 001.404 1.308l4.42.117a1.449 1.449 0 001.485-1.365z"
        fill="#99BBE0"
      />
      <path
        d="M98.863 387.169a1.45 1.45 0 00-.859 1.353l-1.641 132.762a1.45 1.45 0 001.41 1.42l.836.022a1.45 1.45 0 001.486-1.364l12.422-137.964a1.449 1.449 0 00-2.037-1.408l-11.617 5.179z"
        fill="#C3DBF5"
      />
      <path
        d="M444.125 457.281l9.454-114.764a1.45 1.45 0 00-2.078-1.388l-19.638 9.485c-.546.263-.87.838-.813 1.442l7.079 105.196c.069.73.672 1.293 1.404 1.312l3.107.083a1.45 1.45 0 001.485-1.366z"
        fill="#99BBE0"
      />
      <path
        d="M442.828 345.147a1.45 1.45 0 00-.836 1.34l-.87 110.735a1.45 1.45 0 001.411 1.422l.107.003a1.45 1.45 0 001.485-1.366l9.594-117.223-2.199 1.028-8.692 4.061z"
        fill="#C3DBF5"
      />
      <path
        d="M63.969 385.526l.23-8.693 7.225.917c17.232 6.257 51.984 18.778 53.143 18.809 1.159.03 42.403 22.872 62.88 34.29l48.822-9.577 195.283-92.676 28.597-12.288 13.763.365-.346 13.039-2.231 2.115-4.404 2.058c-78.802 37.535-238.903 113.844-248.893 118.798-9.99 4.954-26.86 1.461-34.046-.904l-10.731-5.359c-34.074-18.061-102.934-54.636-105.786-56.452-2.851-1.815-3.525-3.718-3.506-4.442z"
        fill="url(#prefix__paint0_linear_2:30)"
      />
      <path
        d="M321.901 253.92L73.867 367.666c-17.025 7.808-7.44 16.292-.52 19.559 25.745 13.248 82.235 42.487 102.241 53.457 20.005 10.97 40.691 5.43 48.533 1.289 66.797-31.33 206.847-96.863 232.668-108.355 25.822-11.493 17.003-21.537 9.366-25.123-25.261-13.235-80.785-42.449-100.791-53.419-20.006-10.969-37.311-5.34-43.463-1.154z"
        fill="url(#prefix__paint1_linear_2:30)"
      />
      <path
        d="M155.898 335.926c-2.624-1.278-10.065-3.167-18.834-.5 2.827 2.733 10.551 6.659 18.834.5z"
        fill="url(#prefix__paint2_linear_2:30)"
      />
      <path
        d="M138.459 337.486l-5.238-21.161.116-4.346 2.801 3.699 5.18 23.334-2.859-1.526z"
        fill="url(#prefix__paint3_linear_2:30)"
      />
      <path
        d="M148.205 340.645l6.23-18.574 2.33-3.671.505 4.613-6.149 16.984-2.916.648z"
        fill="url(#prefix__paint4_linear_2:30)"
      />
      <path
        d="M141.96 339.754l-2.084-26.244 1.002-4.23 1.985 4.194 1.855 26.8-2.758-.52z"
        fill="url(#prefix__paint5_linear_2:30)"
      />
      <path
        d="M145.096 341.937l.294-28.37 1.355-4.132 1.543 4.32-1.25 28.233-1.942-.051z"
        fill="url(#prefix__paint6_linear_2:30)"
      />
      <g filter="url(#prefix__filter0_d_2:30)">
        <path
          d="M137.068 335.275l.698 28.289c2.834 2.492 9.843 6.061 15.212.404l2.924-28.193c-8.283 6.159-16.007 2.233-18.834-.5z"
          fill="url(#prefix__paint7_linear_2:30)"
        />
        <path
          d="M155.902 335.775c-2.251 2.84-12.488 6.192-18.834-.5 2.827 2.733 10.551 6.659 18.834.5z"
          fill="url(#prefix__paint8_linear_2:30)"
        />
        <path
          d="M155.902 335.775c-2.251 2.84-12.488 6.192-18.834-.5 2.827 2.733 10.551 6.659 18.834.5z"
          fill="url(#prefix__paint9_linear_2:30)"
        />
      </g>
      <path
        d="M332.996 491.255l29.469 9.481 18.834.5c7.289-1.498 23.182-4.893 28.443-6.493 5.262-1.6 5.484 2.803 4.936 5.205l-29.34 12.994 28.417 21.776c2.195 4.698-2.568 5.731-5.224 5.661l-32.803-20.443-7.968-.212c-5.389 2.756-18.676 9.943-28.712 16.635-12.355 6.631-13.319 1.096-12.257-2.5l31.059-23.097c-8.61-3.37-26.24-10.99-27.886-14.513-1.646-3.523 1.336-4.797 3.032-4.994z"
        fill="url(#prefix__paint10_linear_2:30)"
      />
      <path
        d="M330.041 493.351c-.041.114-.086.25-.129.4.1.226.339.567.815 1.068 1.128 1.19 3.329 2.022 4.289 2.289l22.244 8.564c-1.19 1.128-.573 3.368-.115 4.347-15.059-6.199-26.476-13.027-27.181-13.77-.474-.501-.28-1.702-.052-2.498-.137-.31-.01-.403.129-.4zM337.599 536.321c-4.118 2.21-8.032 2.203-9.475 1.923.737-.464 2.795-1.521 5.129-2.039 2.916-.647 13.269-8.346 23.565-13.872 8.236-4.421 6.508-8.526 4.615-10.026 6.877 3.082 14.456 1.592 17.385.462 5.654 5.466 18.529 17.454 24.796 21.68 6.267 4.226 8.825 4.342 9.321 3.872-1.206 1.708-3.909 1.588-5.109 1.314l-33.527-20.462-7.968-.212c-7.862 4.866-24.614 15.149-28.732 17.36z"
        fill="#262A4F"
      />
      <path
        d="M386.254 505.717l-.153 5.795c9.036-3.626 27.258-11.019 27.853-11.583.595-.564.312-2.65.096-3.622l-27.796 9.41z"
        fill="url(#prefix__paint11_linear_2:30)"
      />
      <path
        d="M361.722 501.441l-1.693-18.167.058-2.173 25.353.673-2.711 20.225c-7.139 6.77-16.979 2.449-21.007-.558z"
        fill="#302F4B"
      />
      <path
        d="M315.009 458.882l.538-20.283 21.616 4.924 34.431-13.584 66.72-1.128c-.203-1.455.328-1.441 1.103 13.078.774 14.518-3.169 19.246-4.866 19.442-10.257 4.077-33.432 14.19-44.078 22.027-10.647 7.836-27.159 3.628-34.085.544-7.605-4.793-24.534-15.149-31.411-18.231-6.877-3.082-9.276-5.562-9.968-6.789z"
        fill="url(#prefix__paint12_radial_2:30)"
      />
      <path
        d="M317.836 434.311l15.404-6.84 8.693.231 46.457-2.391 49.046 9.276 1.981 7.302c-12.971 6.179-41.558 19.918-52.143 25.436-10.585 5.518-24.21 1.773-29.7-.789-9.778-4.85-31.042-15.757-37.873-20.577-6.831-4.821-4.09-9.774-1.865-11.648z"
        fill="#3F4F6F"
      />
      <path
        d="M268.776 480.126l1.545-3.583 17.751-13.302c.169 11.844-1.095 35.781-7.5 36.77-8.007 1.238-10.77-3.91-13.61-6.16-14.449-1.834-16.885-19.296-11.795-19.885 4.072-.472 10.77 3.91 13.609 6.16zM320.753 466.284l1.365-2.139 7.872 3.834 7.853 4.557c-.116 4.347 1.11 12.643-5.295 13.633-8.007 1.237-10.77-3.911-13.609-6.161-14.45-1.833-16.886-19.295-11.796-19.885 4.072-.472 10.77 3.91 13.61 6.161z"
        fill="#A33E52"
      />
      <path
        d="M288.2 485.716c-11.59-.308-18.171-7.248-20.013-10.68.502-.711 1.823-3.141 3.089-7.167 4.244-10.463 9.924-46.129 9.924-46.129l10.276-4.802 13.956-6.878 12.487-6.193 22.745-10.269 16.872-7.526 18.603 9.193 36.335-3.385c3.643 17.495 1.798 52.385-34.726 51.995-36.524-.389-61.664-16.376-69.669-24.321 1.103 13.077-5.801 27.392-11.199 39.572-4.318 9.743-7.586 21.787-8.68 26.59z"
        fill="url(#prefix__paint13_linear_2:30)"
      />
      <path
        d="M361.344 406.47l3.032-4.993 4.385-1.334-23.693-8.603-16.144 7.4c25.267 9.37 30.691 8.934 32.42 7.53z"
        fill="url(#prefix__paint14_linear_2:30)"
      />
      <g filter="url(#prefix__filter1_d_2:30)">
        <path
          d="M309.961 321.363a1.45 1.45 0 011.399.125l24.15 16.347c.495.335.733.94.6 1.522l-.446 1.959c-.097.429-.384.79-.779.982l-72.075 35.081c-.458.223-1 .189-1.426-.09l-26.424-17.244a1.448 1.448 0 01-.656-1.252l.08-3.02c.015-.559.35-1.06.861-1.286l74.716-33.124z"
          fill="url(#prefix__paint15_linear_2:30)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M310.401 324.339l-73.144 32.426-.034 1.296 25.057 16.352 70.712-34.417.072-.316-22.663-15.341zm23.484 15.897l-.005-.003zm-22.525-18.748a1.45 1.45 0 00-1.399-.125l-74.716 33.124a1.448 1.448 0 00-.861 1.286l-.08 3.02c-.014.503.235.977.656 1.252l26.424 17.244c.426.279.968.313 1.426.09l72.075-35.081c.395-.192.682-.553.779-.982l.446-1.959a1.449 1.449 0 00-.6-1.522l-24.15-16.347z"
          fill="#324567"
        />
        <path d="M246.007 354.84l-2.936 1.372 2.859 1.525 2.212-1.391-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M239.831 356.126l6.324-2.955 4.598 3.245-4.763 2.996-6.159-3.286zm3.24.086l2.859 1.525 2.212-1.391-2.135-1.506-2.936 1.372z"
          fill="#324567"
        />
        <path d="M250.981 358.596l-2.936 1.372 2.86 1.526 2.211-1.391-2.135-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M244.806 359.882l6.324-2.955 4.598 3.245-4.764 2.997-6.158-3.287zm3.239.086l2.86 1.526 2.211-1.391-2.135-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M255.956 362.353l-2.936 1.372 2.859 1.526 2.212-1.392-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M249.78 363.639l6.324-2.955 4.598 3.245-4.763 2.996-6.159-3.286zm3.24.086l2.859 1.526 2.212-1.392-2.135-1.506-2.936 1.372z"
          fill="#324567"
        />
        <path d="M260.93 366.11l-2.936 1.371 2.86 1.526 2.211-1.391-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M254.755 367.395l6.324-2.954 4.598 3.244-4.764 2.997-6.158-3.287zm3.239.086l2.86 1.526 2.211-1.391-2.135-1.506-2.936 1.371z"
          fill="#324567"
        />
        <path d="M254.071 351.43l-2.936 1.371 2.859 1.526 2.212-1.391-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M247.896 352.715l6.324-2.954 4.598 3.244-4.764 2.997-6.158-3.287zm3.239.086l2.859 1.526 2.212-1.391-2.135-1.506-2.936 1.371z"
          fill="#324567"
        />
        <path d="M259.046 355.186l-2.936 1.372 2.859 1.526 2.212-1.391-2.135-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M252.87 356.472l6.324-2.955 4.598 3.245-4.763 2.996-6.159-3.286zm3.24.086l2.859 1.526 2.212-1.391-2.135-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M264.02 358.943l-2.936 1.372 2.859 1.525 2.212-1.391-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M257.845 360.228l6.324-2.954 4.598 3.245-4.764 2.996-6.158-3.287zm3.239.087l2.859 1.525 2.212-1.391-2.135-1.506-2.936 1.372z"
          fill="#324567"
        />
        <path d="M268.995 362.699l-2.936 1.372 2.859 1.526 2.212-1.391-2.135-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M262.819 363.985l6.324-2.955 4.598 3.245-4.763 2.996-6.159-3.286zm3.24.086l2.859 1.526 2.212-1.391-2.135-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M262.136 348.019l-2.936 1.372 2.859 1.526 2.211-1.391-2.134-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M255.96 349.305l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.24.086l2.859 1.526 2.211-1.391-2.134-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M267.11 351.776l-2.936 1.372 2.859 1.525 2.212-1.391-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M260.935 353.062l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.239.086l2.859 1.525 2.212-1.391-2.135-1.506-2.936 1.372z"
          fill="#324567"
        />
        <path d="M272.085 355.532l-2.936 1.372 2.859 1.526 2.211-1.391-2.134-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M265.909 356.818l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.24.086l2.859 1.526 2.211-1.391-2.134-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M277.059 359.289l-2.936 1.372 2.859 1.525 2.212-1.391-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M270.884 360.575l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.239.086l2.859 1.525 2.212-1.391-2.135-1.506-2.936 1.372z"
          fill="#324567"
        />
        <path d="M270.2 344.609l-2.936 1.372 2.859 1.525 2.212-1.391-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M264.025 345.895l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.239.086l2.859 1.525 2.212-1.391-2.135-1.506-2.936 1.372z"
          fill="#324567"
        />
        <path d="M275.175 348.365l-2.936 1.372 2.859 1.526 2.211-1.391-2.134-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M268.999 349.651l6.324-2.955 4.598 3.245-4.764 2.997-6.158-3.287zm3.24.086l2.859 1.526 2.211-1.391-2.134-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M280.149 352.122l-2.936 1.372 2.859 1.526 2.212-1.392-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M273.974 353.408l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.239.086l2.859 1.526 2.212-1.391-2.135-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M278.264 341.199l-2.936 1.371 2.86 1.526 2.211-1.391-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M272.089 342.484l6.324-2.954 4.598 3.244-4.764 2.997-6.158-3.287zm3.239.086l2.86 1.526 2.211-1.391-2.135-1.506-2.936 1.371z"
          fill="#324567"
        />
        <path d="M283.239 344.955l-2.936 1.372 2.859 1.526 2.212-1.391-2.135-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M277.063 346.241l6.324-2.955 4.598 3.245-4.763 2.996-6.159-3.286zm3.24.086l2.859 1.526 2.212-1.391-2.135-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M288.213 348.712l-2.936 1.372 2.86 1.525 2.211-1.391-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M282.038 349.997l6.324-2.954 4.598 3.245-4.764 2.996-6.158-3.287zm3.239.087l2.86 1.525 2.211-1.391-2.135-1.506-2.936 1.372z"
          fill="#324567"
        />
        <path d="M286.329 337.788l-2.936 1.372 2.859 1.526 2.212-1.391-2.135-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M280.153 339.074l6.324-2.955 4.598 3.245-4.763 2.996-6.159-3.286zm3.24.086l2.859 1.526 2.212-1.391-2.135-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M291.303 341.545l-2.936 1.372 2.859 1.525 2.212-1.391-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M285.128 342.831l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.239.086l2.859 1.525 2.212-1.391-2.135-1.506-2.936 1.372z"
          fill="#324567"
        />
        <path d="M296.278 345.301l-2.936 1.372 2.859 1.526 2.212-1.391-2.135-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M290.102 346.587l6.324-2.955 4.598 3.245-4.763 2.996-6.159-3.286zm3.24.086l2.859 1.526 2.212-1.391-2.135-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M302.701 349.096l-19.808 8.898 2.859 1.526 19.084-8.917-2.135-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M279.605 357.882l23.256-10.446 4.851 3.423-22.003 10.28-6.104-3.257zm3.288.112l2.859 1.526 19.084-8.917-2.135-1.507-19.808 8.898z"
          fill="#324567"
        />
        <path d="M294.393 334.378l-2.936 1.372 2.859 1.525 2.212-1.391-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M288.218 335.664l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.239.086l2.859 1.525 2.212-1.391-2.135-1.506-2.936 1.372z"
          fill="#324567"
        />
        <path d="M299.368 338.134l-2.936 1.372 2.859 1.526 2.211-1.391-2.134-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M293.192 339.42l6.324-2.955 4.598 3.245-4.764 2.997-6.158-3.287zm3.24.086l2.859 1.526 2.211-1.391-2.134-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M304.342 341.891l-2.936 1.372 2.859 1.526 2.212-1.391-2.135-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M298.167 343.177l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.239.086l2.859 1.526 2.212-1.391-2.135-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M309.317 345.648l-2.936 1.371 2.859 1.526 2.211-1.391-2.134-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M303.141 346.933l6.324-2.954 4.598 3.244-4.764 2.997-6.158-3.287zm3.24.086l2.859 1.526 2.211-1.391-2.134-1.506-2.936 1.371z"
          fill="#324567"
        />
        <path d="M302.458 330.968l-2.936 1.371 2.859 1.526 2.211-1.391-2.134-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M296.282 332.253l6.324-2.954 4.598 3.244-4.764 2.997-6.158-3.287zm3.24.086l2.859 1.526 2.211-1.391-2.134-1.506-2.936 1.371z"
          fill="#324567"
        />
        <path d="M307.432 334.724l-2.936 1.372 2.859 1.526 2.212-1.391-2.135-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M301.257 336.01l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.239.086l2.859 1.526 2.212-1.391-2.135-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M312.407 338.481l-2.936 1.372 2.859 1.525 2.211-1.391-2.134-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M306.231 339.767l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.24.086l2.859 1.525 2.211-1.391-2.134-1.506-2.936 1.372z"
          fill="#324567"
        />
        <path d="M317.381 342.237l-2.936 1.372 2.859 1.526 2.212-1.391-2.135-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M311.206 343.523l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.239.086l2.859 1.526 2.212-1.391-2.135-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M310.522 327.557l-2.936 1.372 2.859 1.526 2.212-1.391-2.135-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M304.346 328.843l6.324-2.955 4.598 3.245-4.763 2.996-6.159-3.286zm3.24.086l2.859 1.526 2.212-1.391-2.135-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M315.496 331.314l-2.936 1.372 2.86 1.525 2.211-1.391-2.135-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M309.321 332.6l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.239.086l2.86 1.525 2.211-1.391-2.135-1.506-2.936 1.372z"
          fill="#324567"
        />
        <path d="M320.471 335.07l-2.936 1.372 2.859 1.526 2.212-1.391-2.135-1.507z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M314.295 336.356l6.324-2.955 4.598 3.245-4.763 2.996-6.159-3.286zm3.24.086l2.859 1.526 2.212-1.391-2.135-1.507-2.936 1.372z"
          fill="#324567"
        />
        <path d="M325.446 338.827l-2.936 1.372 2.859 1.525 2.211-1.391-2.134-1.506z" fill="#1B2446" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M319.27 340.113l6.324-2.955 4.598 3.245-4.764 2.996-6.158-3.286zm3.24.086l2.859 1.525 2.211-1.391-2.134-1.506-2.936 1.372z"
          fill="#324567"
        />
      </g>
      <g filter="url(#prefix__filter2_d_2:30)">
        <path
          d="M333.247 318.012c2.38-2.256 5.859-2.261 7.302-1.981 3.158-.641 10.004-.024 12.122 7.571 2.118 7.595-4.101 8.832-7.475 8.5l-12.103-8.295c-.94-.991-2.225-3.538.154-5.795z"
          fill="url(#prefix__paint16_linear_2:30)"
        />
      </g>
      <path
        d="M304.496 336.096c5.077-.107 15.456 2.15 16.353 12.032.898 9.883-2.626 7.905-4.5 5.68l-2.173-.058c-1.671-.769-5.432-2.898-7.109-5.263-1.677-2.364-6.456-2.587-8.635-2.404-.953-.508-2.276-1.655.057-2.173 2.334-.518 6.272.408 7.949.936-1.416-1.245-4.833-3.608-7.166-3.09-2.334.518-2.396-.788-2.135-1.506 1.756-.606 5.665-1.155 8.486.912-1.317-1.008-3.577-2.231-6.275-2.303-.463-.737-.811-2.196 1.507-2.135l.14.002c1.156-.005 2.799-.417 3.501-.63zM345.062 313.271c5.077-.107 15.455 2.15 16.353 12.032.897 9.882-2.627 7.904-4.501 5.68l-2.173-.058c-1.671-.769-5.432-2.899-7.109-5.263-1.677-2.364-6.455-2.588-8.635-2.404-.953-.509-2.275-1.655.058-2.173 2.333-.518 6.272.408 7.949.936-1.417-1.246-4.834-3.608-7.167-3.09-2.333.518-2.395-.789-2.135-1.507 1.757-.605 5.666-1.154 8.486.913-1.317-1.008-3.576-2.232-6.274-2.304-.464-.737-.812-2.196 1.506-2.134l.141.001c1.155-.005 2.799-.416 3.501-.629z"
        fill="#F9B25F"
      />
      <path
        d="M422.878 327.641c8.442-33.991-10.432-34.83-20.923-31.001l-1.468.686-22.572 3.75c-1.239 1.175-5.628 4.49-13.269 8.346-7.642 3.857-9.719 11.099-9.802 14.238l-10.34 34.52-23.655-10.051c-2.192.666-6.596 2.724-6.673 5.621 3.468 5.892 22.052 15.809 29.924 19.642 6.297 3.067 8.902 1.445 9.417.25l9.821-14.962c.741 8.477 2.421 28.915 3.211 42.854 13.995 18.929 37.311 5.34 47.22-3.82l.596-22.456c.346-13.039 3.398-18.757 8.513-47.617z"
        fill="url(#prefix__paint17_linear_2:30)"
      />
      <path
        d="M365.28 285.518c-8.369-12.401-6.581-34.245-4.641-43.617l10.488-12.77 21.154 22.309c.458.978 1.574 6.276 2.379 19.635 1.006 16.699 5.16 24.059 10.211 24.918 1.416 12.215-18.855 9.406-29.167 6.474l5.167-3.487-1.827-13.097-13.764-.365z"
        fill="url(#prefix__paint18_linear_2:30)"
      />
      <path
        d="M366.506 251.61l1.237 8.007c4.52-6.404 7.321-2.706 7.969.211-2.334 33.283 18.372 17.885 25.045 12.264 22.578-31.296 3.058-33.264-1.403-29.033 2.4-24.873-5.312-27.446-9.469-25.623-.972.216-4.228.902-9.474 1.923-14.257-9.077-19.715-4.873-22.398-2.769-8.276 11.378-.509 28.257 8.493 35.02z"
        fill="url(#prefix__paint19_linear_2:30)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M406.295 403.513l.076-.196c-11.513-3.206-34.21-16.566-32.892-44.367 1.318-27.801-2.904-27.14-5.18-23.335-2.53 4.283-8.513 14.852-12.205 22.873-4.616 10.026-7.533 10.673-13.289 9.071-13.236-3.831-23.597-12.225-27.123-15.943l-1.359 1.289a3.016 3.016 0 00-.147.845c3.468 5.892 22.052 15.809 29.924 19.642 6.297 3.067 8.902 1.445 9.417.25l9.821-14.962c.741 8.477 2.421 28.915 3.211 42.854 11.163 15.099 28.257 9.508 39.746 1.979z"
        fill="#76829D"
      />
      <path
        d="M409.961 377.316l74.868-34.982c2.211-1.391 7.496-3.86 10.942-2.609 3.447 1.252 4.231 4.462 4.193 5.911-8.137 15.248-26.25 49.465-33.604 64.348-7.354 14.882-9.956 20.032-18.001 22.718l-64.553 28.732c-6.954-.185-7.637-3.586-7.109-5.263 4.26-14.868 13.286-47.2 15.302-57.585 2.015-10.385 7.425-15.751 9.878-17.136l8.084-4.134z"
        fill="#485A86"
      />
      <path
        d="M399.948 399.522l-16.142 61.912c11.744-5.488 38.896-17.96 53.553-23.949 14.657-5.99 20.864-12.253 22.135-14.635l39.765-77.958c-20.063 9.374-63.852 29.62-78.509 35.61-14.657 5.99-19.975 15.175-20.802 19.02z"
        fill="url(#prefix__paint20_linear_2:30)"
      />
      <path
        d="M434.212 412.183L410.31 473.37c-.013.496.249 1.794 1.405 3.016 5.279 2.524 7.173.191 7.46-1.291 7.72-20.402 23.176-61.802 23.239-64.184-3.436-4.858-6.9-1.176-8.202 1.272z"
        fill="#3B4D75"
      />
      <path
        d="M438.549 412.65l-23.902 61.187c-.013.496.249 1.794 1.405 3.016 1.413.038 2.827.075 3.114-1.407 7.72-20.402 23.175-61.802 23.238-64.184-1.388-2.324-2.553-1.06-3.855 1.388z"
        fill="#58698E"
      />
      <path
        d="M231.792 308.365a1.34 1.34 0 00-.511 1.072c.136 6.475 4.634 19.374 22.005 24.439.333.097.695.069 1.008-.078l16.319-7.625c.497-.232.821-.725.835-1.274l.039-1.464c.019-.724-.496-1.346-1.202-1.505-6.958-1.563-18.804-7.451-20.46-20.877-.118-.96-1.078-1.618-1.987-1.288-5.205 1.894-10.862 4.435-16.046 8.6z"
        fill="url(#prefix__paint21_linear_2:30)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M247.343 298.404c1.881-.685 3.701.693 3.92 2.471 1.545 12.52 12.618 18.131 19.339 19.641 1.338.301 2.373 1.498 2.334 2.957l-.039 1.464a2.897 2.897 0 01-1.67 2.549l-16.319 7.625a2.889 2.889 0 01-2.027.157c-18.062-5.266-22.902-18.783-23.049-25.801a2.79 2.79 0 011.052-2.232c5.36-4.306 11.184-6.912 16.459-8.831zm.98 2.727c-5.121 1.864-10.595 4.333-15.592 8.338.152 5.955 4.337 18.166 20.954 23.014L270 324.86l.038-1.463v-.003a.04.04 0 00-.007-.013.118.118 0 00-.064-.037c-7.193-1.616-19.812-7.78-21.58-22.114a.135.135 0 00-.057-.095l-.007-.004z"
        fill="#000"
        fillOpacity={0.09}
      />
      <path
        d="M175.332 231.906l-1.186 99.279 146.075-68.611 2.674-100.689-2.173-.057-145.39 70.078z"
        fill="url(#prefix__paint22_linear_2:30)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M320.565 161.099l3.074.081-2.705 101.86-147.527 69.292 1.206-100.884 145.952-70.349zm.313 1.458l-144.827 69.807-1.167 97.674 144.625-67.929 2.642-99.519-1.273-.033z"
        fill="#324567"
      />
      <path
        d="M307.167 183.698l-114.884 55.895c-.486.237-.8.724-.814 1.265l-1.885 70.973a1.45 1.45 0 002.073 1.346l114.854-54.772c.491-.235.81-.725.825-1.27l1.914-72.095a1.45 1.45 0 00-2.083-1.342z"
        fill="#52688E"
      />
      <path
        d="M212.085 229.585l-19.82 10.003c-.476.24-.782.722-.796 1.255l-1.885 70.992a1.45 1.45 0 002.07 1.348l19.804-9.404c.493-.234.813-.725.827-1.271l1.901-71.591a1.449 1.449 0 00-2.101-1.332z"
        fill="#405477"
      />
      <path
        d="M308.478 183.653l-69.682 33.266-45.158 22.325a1.45 1.45 0 01-2.091-1.338l.105-3.945a1.448 1.448 0 01.836-1.275l114.803-53.497a1.45 1.45 0 012.061 1.352l-.049 1.842a1.45 1.45 0 01-.825 1.27z"
        fill="#364A6D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M292.754 262.817l1.932-71.34.318.009-1.931 71.34-.319-.009z"
        fill="#364A6D"
      />
      <path
        d="M196.518 233.983a1.77 1.77 0 01-.098.572 1.454 1.454 0 01-.265.465 1.183 1.183 0 01-.398.301.6.6 0 01-.391.061.396.396 0 01-.262-.218 1.032 1.032 0 01-.092-.469l.002-.149c.002-.198.035-.388.099-.568.064-.181.154-.338.268-.47.116-.134.248-.235.395-.303.15-.069.281-.09.395-.062a.382.382 0 01.261.224c.06.123.089.285.087.486l-.001.13zm-.244-.02c.002-.244-.04-.411-.128-.5-.088-.09-.212-.099-.372-.025a.794.794 0 00-.371.367 1.336 1.336 0 00-.143.607l-.002.151c-.002.237.041.403.13.497.089.093.213.103.372.03a.792.792 0 00.372-.361c.089-.169.135-.373.14-.613l.002-.153zM198.024 233.504a1.375 1.375 0 01-.151.63.85.85 0 01-.396.395c-.168.077-.301.08-.396.006l-.008.738-.238.109.022-2.12.217-.1.01.165a.88.88 0 01.405-.385c.168-.076.299-.068.394.026.097.094.143.264.141.511v.025zm-.238.079c.002-.172-.03-.293-.096-.362-.066-.07-.157-.077-.274-.024a.66.66 0 00-.326.36l-.007.732c.07.107.178.127.325.059a.585.585 0 00.272-.273c.069-.132.104-.295.106-.492zM198.897 233.875c-.189.087-.342.09-.459.008-.116-.082-.174-.238-.171-.466v-.048a1.286 1.286 0 01.306-.824.915.915 0 01.31-.244c.181-.084.321-.083.42.002.099.085.147.25.144.494l-.001.109-.942.434c.002.15.041.253.116.312.076.057.173.058.292.003a.644.644 0 00.214-.155c.058-.064.11-.138.154-.22l.144.058a1.07 1.07 0 01-.527.537zm-.016-1.359a.565.565 0 00-.243.227.913.913 0 00-.124.378l.697-.32v-.02c-.006-.13-.037-.218-.095-.264-.057-.047-.136-.047-.235-.001zM199.956 231.835l.006.189a.917.917 0 01.419-.413c.293-.135.44-.021.439.343l-.01 1.012-.238.109.01-1.013c0-.11-.022-.181-.067-.213-.044-.032-.114-.027-.209.017a.57.57 0 00-.203.162.861.861 0 00-.139.241l-.01 1.091-.238.11.015-1.532.225-.103z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M184.313 221.271l130.614-59.597c3.673-1.836 10.825-3.627 10.045 3.891-.78 7.518-2.03 67.361-2.558 96.343-.312 2.649-1.523 8.223-3.872 9.321-2.349 1.097-95.439 45.308-141.691 67.277-2.923.889-8.884 1.504-9.34-3.148-.456-4.651 1.567-68.098 2.635-99.24.058-2.173.764-6.939 3.128-8.616 2.365-1.677 8.345-4.853 11.039-6.231zm-7.571 12.122l-1.07 94.933 143.12-66.514 2.616-98.516-144.666 70.097z"
        fill="url(#prefix__paint23_linear_2:30)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M321.531 160.831c-1.934-.236-4.482.593-6.28 1.491l-.012.006-130.61 59.596c-2.714 1.388-8.626 4.531-10.935 6.169-.972.69-1.683 2.094-2.152 3.731a18.56 18.56 0 00-.672 4.313v.006c-.534 15.57-1.307 39.216-1.889 59.55-.291 10.167-.535 19.505-.677 26.59a671.837 671.837 0 00-.13 8.757c-.014 2.257.006 3.712.058 4.247.098.994.477 1.652.996 2.104.534.466 1.272.759 2.146.904 1.741.288 3.812-.048 5.215-.467 46.266-21.975 139.295-66.158 141.646-67.256.405-.189.829-.609 1.244-1.274.409-.655.769-1.481 1.077-2.382.609-1.785.98-3.769 1.134-5.058.528-28.965 1.778-88.812 2.561-96.368.185-1.781-.115-2.877-.592-3.54-.466-.65-1.189-1.004-2.128-1.119zm3.305.273c.76 1.058 1.062 2.558.857 4.536-.776 7.477-2.026 67.27-2.555 96.281v.036l-.005.036c-.16 1.361-.55 3.47-1.206 5.391-.327.961-.73 1.9-1.219 2.682-.482.771-1.09 1.46-1.859 1.819-2.346 1.096-95.433 45.306-141.687 67.275l-.049.023-.051.016c-1.52.462-3.861.867-5.924.526-1.039-.172-2.06-.542-2.862-1.241-.819-.714-1.356-1.723-1.486-3.055-.062-.628-.079-2.172-.065-4.398.013-2.245.059-5.231.13-8.777.143-7.092.386-16.434.677-26.603a11545.45 11545.45 0 011.89-59.555c.03-1.137.228-2.932.727-4.672.489-1.708 1.314-3.525 2.706-4.513 2.416-1.713 8.447-4.913 11.128-6.285l.015-.007 130.617-59.599c1.875-.936 4.732-1.916 7.092-1.628 1.211.148 2.359.641 3.129 1.712zm-2.672 1.02l-2.66 100.156-144.57 67.188 1.089-96.531 146.141-70.813zM177.462 233.85l-1.053 93.334 141.67-65.84 2.573-96.877-143.19 69.383z"
        fill="#000"
        fillOpacity={0.12}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M241.237 221.417a.724.724 0 01-.327.971l-23.677 11.741a.723.723 0 11-.644-1.298l23.677-11.741a.725.725 0 01.971.327zm-5.8-.151a.724.724 0 01-.32.973l-17.81 8.988a.724.724 0 11-.653-1.294l17.81-8.988a.724.724 0 01.973.321zm11.664 3.171a.724.724 0 01-.333.969l-29.739 14.526a.724.724 0 11-.636-1.302l29.739-14.526a.723.723 0 01.969.333zm-6.418.167a.725.725 0 01-.329.971l-23.176 11.46a.725.725 0 11-.643-1.299l23.177-11.46a.725.725 0 01.971.328zm14.871 9.097a.725.725 0 01-.333.969l-29.739 14.526a.723.723 0 11-.636-1.302l29.739-14.526a.724.724 0 01.969.333zm2.85 1.866a.724.724 0 01-.333.969l-29.739 14.527a.725.725 0 01-.636-1.302l29.739-14.527a.726.726 0 01.969.333zm-.086 3.238a.726.726 0 01-.333.97l-29.739 14.526a.724.724 0 11-.636-1.302l29.739-14.527a.726.726 0 01.969.333zm13.069 2.441a.725.725 0 01-.338.967l-44.505 21.425a.724.724 0 11-.628-1.306l44.504-21.425a.724.724 0 01.967.339zm-13.155.798a.725.725 0 01-.333.969l-29.739 14.526a.723.723 0 11-.636-1.302l29.739-14.526a.724.724 0 01.969.333zm13.078 2.099a.724.724 0 01-.338.967l-44.505 21.426a.725.725 0 01-.628-1.306l44.504-21.426a.724.724 0 01.967.339zm-48.387.088c.2.347.08.79-.267.989l-5.883 3.38a.725.725 0 11-.722-1.256l5.883-3.38c.347-.2.79-.08.989.267zm33.774 1.012a.723.723 0 01-.333.969l-29.739 14.527a.725.725 0 01-.636-1.302l29.739-14.527a.725.725 0 01.969.333zm14.536 1.798a.725.725 0 01-.338.967l-44.504 21.425a.725.725 0 11-.629-1.306l44.504-21.425a.724.724 0 01.967.339zm9.563 1.257c.173.36.02.793-.341.966l-54.22 25.965a.724.724 0 01-.626-1.307l54.22-25.965a.725.725 0 01.967.341zm-58.018-1.171c.199.347.08.79-.267.989l-5.884 3.38a.724.724 0 11-.722-1.257l5.884-3.38a.725.725 0 01.989.268zm48.379 2.811a.724.724 0 01-.339.967l-44.504 21.426a.726.726 0 01-.629-1.306l44.504-21.425a.725.725 0 01.968.338zm9.562 1.257a.725.725 0 01-.341.967l-54.22 25.964a.724.724 0 11-.626-1.307l54.22-25.965a.726.726 0 01.967.341zm-.077 2.898a.724.724 0 01-.341.966l-54.22 25.965a.724.724 0 01-.626-1.307l54.22-25.965a.725.725 0 01.967.341zm-.077 2.897a.725.725 0 01-.341.967l-54.22 25.964a.724.724 0 11-.625-1.307l54.219-25.964a.725.725 0 01.967.34z"
        fill="#405477"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224.653 260.543a.725.725 0 01-.29.983l-8.203 4.464a.725.725 0 01-.693-1.273l8.203-4.464a.725.725 0 01.983.29zm-.077 2.898a.726.726 0 01-.29.983l-8.203 4.464a.725.725 0 01-.693-1.273l8.203-4.464a.724.724 0 01.983.29zm-.077 2.897a.724.724 0 01-.29.983l-8.203 4.464a.724.724 0 11-.693-1.273l8.203-4.464a.725.725 0 01.983.29zm-.231 8.693a.724.724 0 01-.29.983l-8.203 4.464a.725.725 0 01-.693-1.273l8.203-4.464a.724.724 0 01.983.29zm-.154 5.795a.724.724 0 01-.29.983l-8.203 4.464a.726.726 0 01-.693-1.273l8.204-4.464a.724.724 0 01.982.29zm-.076 2.898a.724.724 0 01-.291.982l-8.203 4.464a.724.724 0 11-.693-1.273l8.204-4.464a.725.725 0 01.983.291z"
        fill="#54952C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.633 250.023a.725.725 0 01-.268.989l-5.883 3.38a.725.725 0 01-.722-1.257l5.883-3.38a.726.726 0 01.99.268zm3.837 1.061a.725.725 0 01-.3.98l-9.854 5.235a.724.724 0 11-.68-1.28l9.854-5.235a.725.725 0 01.98.3zm-.146 2.896a.725.725 0 01-.299.98l-9.855 5.235a.724.724 0 11-.68-1.28l9.855-5.235a.723.723 0 01.979.3zm-.145 2.895a.724.724 0 01-.3.98l-9.854 5.236a.725.725 0 11-.68-1.28l9.854-5.236a.726.726 0 01.98.3zm-1.757 12.361a.725.725 0 01-.29.983l-8.203 4.464a.725.725 0 01-.693-1.273l8.203-4.464a.724.724 0 01.983.29zm.132 2.758a.724.724 0 01-.29.983l-8.203 4.464a.725.725 0 01-.693-1.273l8.203-4.464a.725.725 0 01.983.29zm-.154 5.795a.724.724 0 01-.29.983l-8.203 4.464a.726.726 0 01-.693-1.273l8.204-4.464a.724.724 0 01.982.29z"
        fill="#9C6F39"
      />
      <path
        d="M421.19 116.728c12.701 9.239 13.669 29.552 2.162 45.372-11.507 15.82-31.132 21.155-43.833 11.917-12.701-9.239-13.669-29.553-2.162-45.373 11.507-15.819 31.132-21.155 43.833-11.916z"
        fill="url(#prefix__paint24_linear_2:30)"
      />
      <path
        d="M425.128 118.948c11.327 8.239 11.075 27.889-.563 43.889-11.639 16.001-30.256 22.292-41.584 14.053-11.327-8.24-11.075-27.89.563-43.89 11.638-16.001 30.256-22.292 41.584-14.052z"
        fill="#FBC88C"
      />
      <path
        d="M384.679 153.039c-.082.036-.106-.001-.069-.088l.387-.811a.475.475 0 01.217-.215l7.291-3.246c.082-.036.107.023.071.111l-.308.751a.523.523 0 01-.195.229l-7.394 3.269zM381.735 156.526c-.082.036-.105-.001-.069-.088l.388-.811a.466.466 0 01.217-.215l9.312-4.147c.082-.036.127.015.112.093l-.127.624a.303.303 0 01-.175.22l-9.658 4.324zM386.817 156.439c-.082.036-.107-.024-.07-.111l.248-.701c.036-.088.113-.193.195-.229l4.084-1.819c.082-.036.127.015.133.107l-.004.569a.268.268 0 01-.132.225l-4.454 1.959zM407.708 142.36c-1.262.94-2.122 1.607-3.364 2.538-.3.228-.319.26-.607.034-.332-.254-.574-.407-1.018-.446-1.334-.139-2.566.622-3.674 1.991-1.321 1.629-1.937 3.441-1.794 5.293.143 1.828 1.366 2.845 2.996 2.379 1.403-.411 2.53-1.481 3.372-3.062.167-.335.312-.683.495-1.096l-3.942 1.755c-.429.191-.55-.062-.433-.516.218-.831.629-2.244.875-2.968.052-.165.18-.459.487-.595l7.433-3.31c.001.639.042 1.259.001 1.916-.115 1.754-.566 3.516-1.376 5.248-1.326 2.838-3.156 5.048-5.562 6.498-1.982 1.189-3.869 1.58-5.594.929-1.597-.614-2.567-1.932-2.932-3.946-.431-2.386.073-4.928 1.29-7.504 1.309-2.782 3.139-4.993 5.455-6.521 1.894-1.245 3.749-1.811 5.487-1.284 1.136.323 1.985 1.08 2.584 2.185.136.152.062.304-.179.482z"
        fill="#00ACD7"
      />
      <path
        d="M415.31 152.055c-1.862.782-3.596.939-5.117.197-1.283-.635-2.137-1.792-2.5-3.452-.539-2.433-.058-5.012 1.195-7.675 1.345-2.87 3.066-4.819 5.464-6.383 2.056-1.341 4.032-1.984 5.898-1.42 1.696.523 2.807 1.754 3.219 3.842.553 2.947-.076 5.829-1.833 8.834-1.246 2.139-2.836 3.841-4.706 5.123-.544.36-1.094.629-1.62.934zm4.245-11.446c-.04-.289-.055-.519-.111-.731-.518-2.111-2.462-2.57-4.369-1.201-1.867 1.329-3.003 3.23-3.309 5.589-.249 1.956.648 3.426 2.167 3.506 1.159.052 2.278-.518 3.319-1.62 1.551-1.66 2.332-3.521 2.303-5.543z"
        fill="#00ACD7"
      />
      <path
        d="M339.401 20.689c15.709 11.426 16.906 36.55 2.674 56.116-14.232 19.566-38.503 26.164-54.212 14.738-15.708-11.426-16.905-36.55-2.674-56.116 14.232-19.566 38.504-26.164 54.212-14.738z"
        fill="url(#prefix__paint25_linear_2:30)"
      />
      <path
        d="M344.271 23.434c14.01 10.19 13.698 34.494-.696 54.283s-37.42 27.57-51.43 17.38c-14.01-10.191-13.698-34.494.696-54.283 14.394-19.79 37.42-27.57 51.43-17.38z"
        fill="#C5F1FF"
      />
      <path
        d="M302.305 73.622l-7.29-5.006 23.672-33.018 14.58-5.163-30.962 43.187zm30.962-20.453l-14.58 5.162-5.461 7.618 7.291 5.006"
        fill="#42A5F5"
      />
      <path d="M313.226 81.123l5.461 3.75 14.58-5.163-12.75-8.755" fill="#0D47A1" />
      <path d="M305.952 76.117l7.28-10.156 7.279 4.998-7.279 10.156-7.28-4.998z" fill="#42A5F5" />
      <path
        d="M313.232 81.115l7.279-10.154 1.016.698-7.279 10.154-1.016-.698z"
        fill="url(#prefix__paint26_linear_2:30)"
      />
      <path d="M313.226 81.123l10.817-7.72-3.526-2.45" fill="url(#prefix__paint27_linear_2:30)" />
      <path
        d="M104.656 82.867c12.3 8.946 13.237 28.619 2.093 43.939-11.143 15.321-30.148 20.488-42.449 11.541-12.3-8.947-13.237-28.62-2.093-43.94 11.144-15.32 30.149-20.487 42.449-11.54z"
        fill="url(#prefix__paint28_linear_2:30)"
      />
      <path
        d="M108.469 85.016c10.97 7.98 10.726 27.009-.545 42.504-11.271 15.495-29.301 21.588-40.27 13.609-10.97-7.98-10.727-27.009.544-42.505 11.271-15.495 29.3-21.587 40.271-13.608z"
        fill="#D7D7D7"
      />
      <g clipPath="url(#prefix__clip0_2:30)">
        <path d="M88.049 117.637v-6.629l-5.412-1.397-5.41 5.229v6.629l5.41 1.399 5.412-5.231z" fill="#3B8739" />
        <path
          d="M109.358 109.084l3.526.912-3.526 3.409-5.411-1.398v-6.627l5.411-5.231 3.279.848c.333 1.374.536 2.823.611 4.329l-2.005 1.939v-2.308l-1.885-.487-1.885 1.822v2.308l1.885.484z"
          fill="#333"
        />
        <path d="M110.41 107.048v-1.288l-1.05-.272-1.051 1.016v1.288l1.051.271 1.05-1.015z" fill="#66A060" />
        <path
          d="M74.67 115.747v8.741l-3.61-.906V119.1l-1.801-.466-1.802 1.742v4.48l-2.05 1.966a25.692 25.692 0 01-.19-3.147c0-1.996.216-4.015.624-6.023l3.418-3.303 5.411 1.398z"
          fill="#333"
        />
        <path d="M82.635 109.61l5.411 8.025-5.41 5.231-5.41-8.026 5.41-5.23z" fill="#6DA75D" />
        <path d="M77.226 121.469l1.857-3.872-1.857-2.757v6.629z" fill="#55A344" />
        <path d="M86.243 114.962l1.803-3.954-5.409-1.397 3.606 5.351z" fill="#639D57" />
        <path
          d="M97.751 96.576v8.794l-1.814-.468-5.412 5.231v6.629l5.412 1.398 5.411-5.23V97.345l-3.597-.77zm-.01 15.418l-1.804 1.743-1.804-.465v-2.208l1.804-1.743 1.804.465v2.208z"
          fill="#333"
        />
        <path
          d="M91.705 124.524s-.107-.93-1.083-.584c-.977.346-1.646.719-1.646 1.292 0 .574 1.9-.099 2.622-.128.723-.031 1.36.33 1.041 1.479-.318 1.149-1.295 1.608-2.804 2.143-1.509.534-1.848-.674-1.848-1.194l.85-.301s-.107.85.891.63c.998-.22 1.954-.481 2.082-1.345.17-1.142-3.23.602-3.526-.352-.253-.806-.107-2.034 1.592-2.817 1.699-.783 2.633-.316 2.633.87l-.804.307z"
          fill="#66A060"
        />
        <path
          d="M83.496 131.655l1.879.484c.945.244 2.124-.897 2.124-2.053v-5.727l-.765.271v5.5c0 .63-.643 1.255-1.16 1.12l-1.31-.338v-5.87l4.791-4.631 4.792 1.237v5.87l-4.792 4.631-1.38-.357-.902.705 2.282.588 5.557-5.371v-6.806l-5.557-1.435-5.556 5.371-.002 6.811z"
          fill="#66A060"
        />
      </g>
      <path
        d="M242.3 109.095c15.709 11.426 16.906 36.55 2.674 56.116-14.232 19.566-38.504 26.164-54.212 14.738-15.709-11.426-16.906-36.55-2.674-56.116 14.232-19.566 38.503-26.164 54.212-14.738z"
        fill="url(#prefix__paint29_linear_2:30)"
      />
      <path
        d="M247.17 111.84c14.009 10.19 13.698 34.493-.696 54.282-14.395 19.789-37.421 27.57-51.43 17.38-14.01-10.191-13.698-34.494.696-54.283s37.42-27.57 51.43-17.379z"
        fill="#222"
      />
      <path
        d="M249.809 137.23c0-4.029-4.733-6.1-11.99-5.791 1.675-8.501.93-14.499-2.349-15.297-.756-.193-1.64-.09-2.605.266v2.765c.535-.198.965-.245 1.325-.167 1.582.383 2.268 3.812 1.733 8.744a47.95 47.95 0 01-.593 3.864c-2.279.246-4.768.705-7.385 1.373-1.57-1.714-3.198-3.196-4.838-4.413 3.792-5.155 7.35-8.525 9.769-9.418v-2.764c-3.198 1.18-7.385 5.154-11.618 10.93-4.233-2.628-8.42-3.488-11.618-2.308v2.764c2.407-.888 5.978-.16 9.769 2.173a96.688 96.688 0 00-4.803 7.957 72.915 72.915 0 00-7.397 4.092 32.886 32.886 0 01-.604-3.371c-.547-4.534.128-8.464 1.698-10.023.349-.352.802-.618 1.337-.816v-2.764c-.977.36-1.861.91-2.628 1.664-3.268 3.214-4.001 9.744-2.315 16.981-7.233 5.049-11.943 10.592-11.943 14.608 0 4.029 4.733 6.1 11.99 5.791-1.675 8.501-.93 14.499 2.349 15.297.756.193 1.64.09 2.617-.271 3.198-1.18 7.385-5.154 11.618-10.93 4.233 2.628 8.42 3.488 11.618 2.308a7.324 7.324 0 002.628-1.663c3.268-3.214 4.001-9.744 2.315-16.981 7.21-5.028 11.92-10.584 11.92-14.6zm-15.142-2.682a79.062 79.062 0 01-1.57 5.476 40.82 40.82 0 00-3.198-4.696 48.401 48.401 0 014.768-.78zm-5.326 15.167a105.871 105.871 0 01-2.803 5.769 72.026 72.026 0 01-5.257 2.187 70.384 70.384 0 01-5.233 1.695 41.357 41.357 0 01-2.814-3.672 41.528 41.528 0 01-2.419-4.041 100.337 100.337 0 012.407-5.834 105.871 105.871 0 012.803-5.769 71.746 71.746 0 015.256-2.187 71.045 71.045 0 015.234-1.696 41.376 41.376 0 012.814 3.673 41.409 41.409 0 012.419 4.041 107.347 107.347 0 01-2.407 5.834zm3.756-2.997a39.47 39.47 0 011.605 4.341 70.581 70.581 0 01-4.791 2.759c.57-1.164 1.139-2.354 1.674-3.555a110.716 110.716 0 001.512-3.545zm-11.792 17.577a29.074 29.074 0 01-3.233-2.774 81.001 81.001 0 003.198-1.094 68.96 68.96 0 003.233-1.279 80.5 80.5 0 01-3.198 5.147zm-8.653-4.11a48.353 48.353 0 01-4.768.78c.43-1.758.965-3.604 1.57-5.475.477.815.977 1.623 1.523 2.413.547.79 1.105 1.551 1.675 2.282zm8.595-28.966a29.058 29.058 0 013.233 2.774 78.868 78.868 0 00-3.199 1.093 69.397 69.397 0 00-3.233 1.279 80.468 80.468 0 013.199-5.146zm-8.606 10.476a108.594 108.594 0 00-3.187 7.088 39.47 39.47 0 01-1.605-4.341 77.005 77.005 0 014.792-2.747zm-10.525 19.403c-4.117-.353-6.781-1.825-6.781-3.772 0-1.946 2.664-5.395 6.781-8.773 1-.828 2.093-1.64 3.221-2.441a43.32 43.32 0 002.617 6.584c-1.07 2.973-1.931 5.807-2.582 8.465-1.151.04-2.245.022-3.256-.063zm6.256 15.405c-1.581-.383-2.267-3.812-1.732-8.744.127-1.213.337-2.517.593-3.864 2.279-.246 4.768-.705 7.385-1.373 1.57 1.714 3.198 3.196 4.838 4.413-3.792 5.155-7.35 8.526-9.769 9.418-.524.181-.966.232-1.315.15zm27.586-19.623c.547 4.534-.128 8.464-1.698 10.023-.349.352-.802.618-1.337.816-2.408.888-5.978.16-9.769-2.173a97.025 97.025 0 004.803-7.957 72.793 72.793 0 007.396-4.093c.268 1.154.477 2.279.605 3.384zm4.478-9.92a55.462 55.462 0 01-3.222 2.441 43.418 43.418 0 00-2.616-6.584c1.069-2.973 1.93-5.807 2.581-8.464a28.418 28.418 0 013.268.059c4.117.352 6.78 1.824 6.78 3.771-.011 1.95-2.674 5.399-6.791 8.777z"
        fill="#61DAFB"
      />
      <path
        d="M221.27 153.424c2.935-1.083 5.315-4.497 5.315-7.626 0-3.129-2.38-4.787-5.315-3.704-2.935 1.083-5.315 4.497-5.315 7.626 0 3.128 2.38 4.787 5.315 3.704z"
        fill="#61DAFB"
      />
      <path
        d="M119.431 236.439c17.764 12.921 19.117 41.332 3.023 63.458-16.094 22.126-43.54 29.588-61.304 16.666-17.764-12.921-19.118-41.332-3.024-63.457 16.094-22.126 43.541-29.588 61.305-16.667z"
        fill="url(#prefix__paint30_linear_2:30)"
      />
      <path
        d="M124.937 239.543c15.843 11.524 15.491 39.007-.787 61.385-16.277 22.378-42.316 31.177-58.158 19.653-15.843-11.523-15.49-39.006.787-61.384s42.316-31.177 58.158-19.654z"
        fill="#A8D0FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.074 263.572c-.758.843-1.197 1.779-1.537 3.281-.494 2.177-.976 3.201-1.955 4.146-.79.764-2.295 1.336-2.97 1.129-2.167-.666-2.822-.61-4.006.344-1.74 1.402-2.32 3.55-1.497 5.554.75 1.825.426 3.392-1.084 5.252-.547.675-.966.951-2.684 1.771-2.482 1.185-3.441 2.547-3.441 4.889 0 1.492.554 2.074 2.46 2.586 1.846.496 1.844 2.941-.004 5.192-2.31 2.812-2.955 4.577-2.283 6.243.466 1.158 1.213 1.218 3.245.261 2.454-1.155 3.319-1.071 4.042.392.248.503.172 1.621-.193 2.834-.953 3.167-.257 4.81 1.819 4.295 1.012-.252 1.59-.802 3.59-3.421.373-.49 1.035-.966 1.933-1.391 1.433-.68 2.32-.147 2.9 1.742.653 2.129 1.364 2.519 3.09 1.696 1.787-.852 2.52-1.887 3.029-4.272.856-4.02 2.96-5.913 5.463-4.915 1.162.464 1.278.457 2.555-.152 2.622-1.25 3.471-3.517 2.424-6.468-.63-1.777-.552-2.451.482-4.117.34-.548.58-.841 1.052-1.287l.611-.578 1.51-.726c2.623-1.26 3.601-2.578 3.601-4.85 0-1.521-.509-2.131-2.036-2.441-2.524-.512-2.516-2.913.018-6.03 1.841-2.264 2.456-4.139 1.835-5.596-.514-1.207-1.186-1.246-3.495-.201l-1.743.788-.425-.054c-1.383-.176-2.106-1.479-1.654-2.981.83-2.764.949-3.97.47-4.821-.918-1.633-3.633-.48-5.477 2.326-1.014 1.544-2.584 2.487-3.675 2.208-.65-.167-1.021-.768-1.628-2.646-.27-.833-.615-1.229-1.208-1.382l-.47-.121-1.136.543c-1.112.532-1.145.553-1.528.978zm4.108 7.589c3.742-.821 6.978.363 8.704 3.187 5.484 8.974-4.523 26.524-15.79 27.691-8.529.883-11.383-9.975-5.354-20.37 3.096-5.337 8.085-9.551 12.44-10.508z"
        fill="#5780C2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.422 252.913c-.759.843-1.198 1.779-1.538 3.28-.493 2.178-.976 3.202-1.954 4.147-.791.764-2.296 1.336-2.971 1.129-2.166-.666-2.822-.61-4.006.344-1.74 1.402-2.32 3.55-1.496 5.554.75 1.825.426 3.392-1.084 5.252-.548.675-.967.951-2.685 1.771-2.482 1.185-3.44 2.547-3.44 4.889 0 1.491.553 2.074 2.46 2.586 1.846.496 1.843 2.941-.005 5.192-2.31 2.812-2.955 4.577-2.283 6.243.467 1.158 1.213 1.217 3.246.261 2.453-1.155 3.318-1.071 4.041.392.248.502.172 1.621-.193 2.834-.953 3.167-.257 4.81 1.82 4.295 1.012-.252 1.59-.802 3.588-3.421.374-.49 1.036-.966 1.934-1.391 1.434-.68 2.321-.147 2.9 1.742.654 2.129 1.364 2.519 3.091 1.696 1.786-.852 2.52-1.887 3.028-4.272.856-4.02 2.961-5.913 5.463-4.915 1.163.464 1.278.457 2.556-.152 2.621-1.25 3.471-3.518 2.423-6.468-.63-1.778-.551-2.451.482-4.117.341-.548.58-.841 1.052-1.288l.612-.577 1.51-.726c2.623-1.261 3.601-2.578 3.601-4.85 0-1.521-.509-2.132-2.036-2.441-2.524-.513-2.517-2.914.018-6.03 1.841-2.264 2.455-4.139 1.834-5.596-.514-1.207-1.186-1.246-3.495-.201l-1.742.788-.425-.054c-1.384-.176-2.107-1.479-1.655-2.981.831-2.764.949-3.97.471-4.821-.918-1.633-3.634-.48-5.477 2.326-1.015 1.544-2.584 2.487-3.676 2.208-.651-.167-1.021-.769-1.628-2.647-.269-.833-.614-1.228-1.207-1.381l-.47-.121-1.137.543c-1.111.531-1.145.553-1.527.978zm4.108 7.589c3.742-.821 6.977.363 8.703 3.187 5.484 8.974-4.523 26.524-15.789 27.69-8.53.884-11.383-9.974-5.355-20.369 3.096-5.337 8.086-9.552 12.441-10.508z"
        fill="#134C9D"
      />
      <path
        d="M75.093 293.682c-.04.02-.078.022-.11.006-.029-.023-.043-.057-.043-.103v-4.431c0-.05.014-.098.043-.143a.29.29 0 01.11-.101l1.6-.763c.603-.288 1.071-.352 1.403-.192.333.16.507.538.523 1.134.005.13.007.304.007.522 0 .219-.002.392-.007.522-.02.641-.19 1.193-.51 1.654-.316.456-.778.828-1.385 1.118l-1.63.777zm1.6-1.744c.271-.13.47-.295.597-.497.127-.206.195-.467.203-.785.009-.136.013-.308.013-.517 0-.209-.004-.376-.013-.499-.008-.3-.082-.49-.221-.569-.136-.081-.339-.057-.61.072l-.615.294v2.809l.646-.308zM79.498 291.581c-.04.02-.078.022-.11.005-.03-.022-.044-.056-.044-.102v-4.431c0-.05.015-.098.044-.144a.294.294 0 01.11-.1l2.874-1.371c.045-.021.082-.023.11-.005.03.018.044.052.044.102v.641a.285.285 0 01-.154.244l-1.963.936v.921l1.828-.872c.045-.022.082-.021.11.002.03.018.044.052.044.102v.593a.29.29 0 01-.044.143.266.266 0 01-.11.101l-1.828.872v.947l2.012-.96c.045-.021.082-.023.111-.005.029.018.043.053.043.102v.641a.29.29 0 01-.043.144.264.264 0 01-.11.1l-2.924 1.394zM84.481 289.205c-.131.062-.215.034-.252-.085l-1.255-3.764-.013-.056c0-.036.013-.074.037-.113a.241.241 0 01.099-.094l.763-.364c.057-.028.104-.032.141-.013a.129.129 0 01.08.084l.874 2.733.868-3.563a.474.474 0 01.074-.158.387.387 0 01.147-.125l.77-.367c.032-.016.061-.014.086.006.028.014.043.039.043.075l-.013.068-1.255 4.962a.457.457 0 01-.252.325l-.942.449zM107.468 278.309c-.579.276-1.034.336-1.366.181-.333-.155-.509-.532-.53-1.132a20.636 20.636 0 01-.006-.583c0-.264.002-.462.006-.596a2.98 2.98 0 01.536-1.639c.34-.49.794-.87 1.36-1.14.566-.27 1.019-.323 1.36-.158.34.161.519.537.535 1.129.008.26.012.455.012.587 0 .127-.004.325-.012.592a2.955 2.955 0 01-.529 1.637c-.333.472-.788.846-1.366 1.122zm0-.982c.225-.108.404-.268.535-.48.135-.215.207-.479.215-.792.009-.267.013-.455.013-.564 0-.119-.004-.303-.013-.554-.008-.305-.08-.5-.215-.586-.135-.085-.314-.075-.535.031-.222.105-.4.266-.536.48-.131.213-.203.477-.215.791-.004.13-.006.317-.006.562 0 .241.002.427.006.557.012.303.084.498.215.585.132.088.31.078.536-.03zM110.242 276.917c-.041.02-.078.021-.11.005-.029-.022-.043-.056-.043-.102v-4.431a.28.28 0 01.153-.244l1.723-.822c.526-.251.938-.313 1.237-.188.304.124.456.442.456.956 0 .509-.15.964-.45 1.366-.299.398-.713.722-1.243.975l-.732.349v1.493a.25.25 0 01-.049.146.268.268 0 01-.111.101l-.831.396zm1.693-3.411a1.05 1.05 0 00.424-.353.927.927 0 00.154-.53c0-.186-.049-.311-.148-.373-.094-.068-.238-.057-.43.035l-.72.344v1.22l.72-.343zM115.853 274.309c-.39.186-.724.282-1.003.288-.279.006-.49-.06-.634-.196-.139-.142-.213-.334-.221-.576a.21.21 0 01.037-.113.246.246 0 01.098-.095l.775-.369c.05-.024.089-.031.117-.022a.178.178 0 01.099.042.35.35 0 00.258.17c.119.02.277-.017.474-.111.234-.111.412-.237.536-.378.123-.14.184-.281.184-.422 0-.1-.033-.166-.098-.198-.062-.035-.16-.044-.296-.03a5.562 5.562 0 00-.603.117c-.492.122-.861.132-1.107.031-.242-.107-.363-.365-.363-.774 0-.278.069-.559.209-.843.139-.285.338-.55.597-.796.258-.246.56-.452.904-.616.357-.17.667-.25.929-.239.263.011.462.089.597.234.14.138.214.305.222.501a.22.22 0 01-.037.12.226.226 0 01-.092.085l-.813.387a.255.255 0 01-.123.032.14.14 0 01-.08-.051c-.024-.093-.092-.149-.203-.169-.106-.022-.24.005-.4.082a1.223 1.223 0 00-.424.311.6.6 0 00-.148.391c0 .096.027.163.08.201a.494.494 0 00.271.048 3.89 3.89 0 00.541-.102c.382-.104.685-.151.911-.141.23.004.398.074.505.209.106.131.16.335.16.613 0 .304-.08.608-.24.912a3.054 3.054 0 01-.659.832 3.994 3.994 0 01-.96.635z"
        fill="#134C9D"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_2:30"
          x1={133.118}
          y1={429.406}
          x2={464.726}
          y2={307.73}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#99BBE0" />
          <stop offset={1} stopColor="#E5F1FE" />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear_2:30"
          x1={231.686}
          y1={293.569}
          x2={337.824}
          y2={391.348}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C3DBF5" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="prefix__paint2_linear_2:30"
          x1={154.337}
          y1={340.083}
          x2={123.185}
          y2={339.407}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B23850" />
          <stop offset={1} stopColor="#E67D91" />
        </linearGradient>
        <linearGradient
          id="prefix__paint3_linear_2:30"
          x1={131.087}
          y1={314.819}
          x2={133.279}
          y2={314.152}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#324567" />
          <stop offset={1} stopColor="#7F9BCD" />
        </linearGradient>
        <linearGradient
          id="prefix__paint4_linear_2:30"
          x1={153.376}
          y1={319.682}
          x2={155.6}
          y2={320.236}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#324567" />
          <stop offset={1} stopColor="#7F9BCD" />
        </linearGradient>
        <linearGradient
          id="prefix__paint5_linear_2:30"
          x1={139.745}
          y1={317.203}
          x2={142.733}
          y2={317.166}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9B25F" />
          <stop offset={1} stopColor="#FFD6A6" />
        </linearGradient>
        <linearGradient
          id="prefix__paint6_linear_2:30"
          x1={145.544}
          y1={317.314}
          x2={147.641}
          y2={317.56}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8590AA" />
          <stop offset={1} stopColor="#B6C0D7" />
        </linearGradient>
        <linearGradient
          id="prefix__paint7_linear_2:30"
          x1={136.683}
          y1={349.762}
          x2={154.068}
          y2={350.224}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B23850" />
          <stop offset={1} stopColor="#E67D91" />
        </linearGradient>
        <linearGradient
          id="prefix__paint8_linear_2:30"
          x1={136.683}
          y1={349.762}
          x2={154.068}
          y2={350.224}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B23850" />
          <stop offset={1} stopColor="#E67D91" />
        </linearGradient>
        <linearGradient
          id="prefix__paint9_linear_2:30"
          x1={136.683}
          y1={349.762}
          x2={154.068}
          y2={350.224}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B23850" />
          <stop offset={1} stopColor="#E67D91" />
        </linearGradient>
        <linearGradient
          id="prefix__paint10_linear_2:30"
          x1={328.201}
          y1={535.346}
          x2={412.64}
          y2={494.82}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#302F4B" />
          <stop offset={1} stopColor="#66658A" />
        </linearGradient>
        <linearGradient
          id="prefix__paint11_linear_2:30"
          x1={386.158}
          y1={509.339}
          x2={414.012}
          y2={497.756}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#262A4F" />
          <stop offset={1} stopColor="#262A4F" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="prefix__paint13_linear_2:30"
          x1={274.475}
          y1={483.902}
          x2={369.145}
          y2={385.656}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B8BEB" />
          <stop offset={1} stopColor="#25456C" />
        </linearGradient>
        <linearGradient
          id="prefix__paint14_linear_2:30"
          x1={336.067}
          y1={402.9}
          x2={342.952}
          y2={389.309}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#274A75" />
          <stop offset={1} stopColor="#09203C" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="prefix__paint15_linear_2:30"
          x1={242.744}
          y1={368.526}
          x2={324.266}
          y2={328.647}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#394D71" />
          <stop offset={1} stopColor="#3B5688" />
          <stop offset={1} stopColor="#9CB1D8" />
        </linearGradient>
        <linearGradient
          id="prefix__paint16_linear_2:30"
          x1={338.792}
          y1={327.583}
          x2={345.562}
          y2={318.339}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#324567" />
          <stop offset={1} stopColor="#6882B0" />
        </linearGradient>
        <linearGradient
          id="prefix__paint17_linear_2:30"
          x1={373.255}
          y1={340.096}
          x2={429.968}
          y2={333.629}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8590AA" />
          <stop offset={1} stopColor="#E3E7F2" />
        </linearGradient>
        <linearGradient
          id="prefix__paint18_linear_2:30"
          x1={366.043}
          y1={284.088}
          x2={391.839}
          y2={268.101}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9B25F" />
          <stop offset={1} stopColor="#FFEDD8" />
        </linearGradient>
        <linearGradient
          id="prefix__paint19_linear_2:30"
          x1={397.834}
          y1={218.372}
          x2={367.84}
          y2={255.995}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C5CE" />
          <stop offset={1} stopColor="#B23850" />
        </linearGradient>
        <linearGradient
          id="prefix__paint20_linear_2:30"
          x1={499.259}
          y1={344.892}
          x2={384.569}
          y2={460.004}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6677A0" />
          <stop offset={1} stopColor="#6677A0" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="prefix__paint21_linear_2:30"
          x1={236.334}
          y1={309.64}
          x2={268.527}
          y2={325.717}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#324567" />
          <stop offset={1} stopColor="#627EB1" />
        </linearGradient>
        <linearGradient
          id="prefix__paint22_linear_2:30"
          x1={173.088}
          y1={289.113}
          x2={321.414}
          y2={217.663}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBEAF9" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="prefix__paint23_linear_2:30"
          x1={168.934}
          y1={281.754}
          x2={324.35}
          y2={216.291}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#324567" />
          <stop offset={1} stopColor="#9FB7E2" />
        </linearGradient>
        <linearGradient
          id="prefix__paint24_linear_2:30"
          x1={374.584}
          y1={166.812}
          x2={404.299}
          y2={114.188}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B08450" />
          <stop offset={1} stopColor="#DFB079" />
        </linearGradient>
        <linearGradient
          id="prefix__paint25_linear_2:30"
          x1={281.76}
          y1={82.632}
          x2={318.511}
          y2={17.547}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3F98B5" />
          <stop offset={1} stopColor="#B2ECFF" />
        </linearGradient>
        <linearGradient
          id="prefix__paint26_linear_2:30"
          x1={316.873}
          y1={76.036}
          x2={317.874}
          y2={76.754}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.2} stopOpacity={0.15} />
          <stop offset={0.85} stopColor="#616161" stopOpacity={0.01} />
        </linearGradient>
        <linearGradient
          id="prefix__paint27_linear_2:30"
          x1={313.229}
          y1={77.328}
          x2={324.046}
          y2={77.328}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.2} stopOpacity={0.55} />
          <stop offset={0.85} stopColor="#616161" stopOpacity={0.01} />
        </linearGradient>
        <linearGradient
          id="prefix__paint28_linear_2:30"
          x1={59.521}
          y1={131.369}
          x2={88.298}
          y2={80.406}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D7D7D7" />
          <stop offset={1} stopColor="#F3F3F3" />
        </linearGradient>
        <linearGradient
          id="prefix__paint29_linear_2:30"
          x1={184.658}
          y1={171.038}
          x2={221.409}
          y2={105.953}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#222" />
          <stop offset={1} stopColor="#888" />
        </linearGradient>
        <linearGradient
          id="prefix__paint30_linear_2:30"
          x1={54.248}
          y1={306.486}
          x2={95.807}
          y2={232.886}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5399EB" />
          <stop offset={1} stopColor="#D8E9FD" />
        </linearGradient>
        <filter
          id="prefix__filter0_d_2:30"
          x={131.232}
          y={333.275}
          width={27.669}
          height={39.951}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx={-1} dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2:30" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2:30" result="shape" />
        </filter>
        <filter
          id="prefix__filter1_d_2:30"
          x={226.826}
          y={316.242}
          width={110.775}
          height={68.219}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx={-3} dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.245049 0 0 0 0 0.42529 0 0 0 0 0.591667 0 0 0 0.35 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2:30" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2:30" result="shape" />
        </filter>
        <filter
          id="prefix__filter2_d_2:30"
          x={325.601}
          y={312.557}
          width={29.776}
          height={24.776}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx={-2} dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2:30" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2:30" result="shape" />
        </filter>
        <radialGradient
          id="prefix__paint12_radial_2:30"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-84.08608 -.0587 .11885 -170.24396 407.429 445.388)"
        >
          <stop stopColor="#6677A0" />
          <stop offset={1} stopColor="#3F4F6F" />
        </radialGradient>
        <clipPath id="prefix__clip0_2:30">
          <path fill="#fff" transform="matrix(.94264 -.3338 0 1 65.217 98.18)" d="M0 0h50.989v50.989H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default mainIllustration;
